import React from 'react';

import { EMOJI_LIB_ENDPOINT_BASE } from '../../../../constants/pro-custom-prints';
import getConfig from '../../../../util/config';

const DeliveredByWaldoBadge = () => {
  const config = getConfig();

  return (
    <span className="account-card-delivered-by-badge">
      Delivered with{' '}
      <img src={`${EMOJI_LIB_ENDPOINT_BASE}/svg/2764.svg`} alt="" /> by Waldo
      &copy; {config?.date?.currentYear}
    </span>
  );
};

export default DeliveredByWaldoBadge;
